import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { RaOptions } from "src/app/models/RaOptions";
import { ServiceRequest } from "src/app/models/ServiceRequest";
import { Tool } from "src/app/models/Tool";

@Component({
  selector: "app-service-request-service-form",
  templateUrl: "./service-request-service-form.component.html",
  standalone: false,
})
export class ServiceRequestServiceFormComponent implements AfterViewInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("servicesForm") servicesForm: FormGroupDirective;
  @Input() ra: ServiceRequest;
  equipmentList: Tool[] = [];
  @Input()
  set equipment(value: Tool[]) {
    this.equipmentList = value;
    this.dataSource.data = [...(this.equipmentList || [])];
  }
  @Input() isRaResultReceived: boolean;
  @Input() showValidationErrors: boolean;
  @Output() startRequestClick = new EventEmitter<void>();
  @Output() removeAll = new EventEmitter<void>();
  @Output() formChanged = new EventEmitter<Tool[]>();

  @Input() options: RaOptions;

  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;
  dataSource = new MatTableDataSource<Tool>([]);
  columns = [
    // ToolId and the serial number are exchanged intentionally
    { key: "serialNumber", title: LocalizationConstants.TOOL_TOOL_ID },
    { key: "toolId", title: LocalizationConstants.TOOL_SERIAL_NUMBER },
    { key: "modelNumber", title: LocalizationConstants.TOOL_MODEL_NUMBER },
    {
      key: "requestedService",
      title: LocalizationConstants.SERVICE_REQUEST_REQUESTED_SERVICE,
    },
    {
      key: "maxPrice",
      title: LocalizationConstants.SERVICE_REQUEST_MAX_PRICE_PERCENT,
    },
    {
      key: "customerComments",
      title: LocalizationConstants.SERVICE_REQUEST_CUSTOMER_COMMENTS,
    },
  ];

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  onMaxPriceChange() {
    this.onFormChanged();
  }

  onServiceChange() {
    this.onFormChanged();
  }

  onFormChanged() {
    this.formChanged.emit(this.dataSource.data);
  }

  get isServiceFormInvalid(): boolean {
    return Boolean(
      this.showValidationErrors && this.servicesForm && this.servicesForm.form.invalid,
    );
  }

  columnKeysAll = [...this.columns.map((x) => x.key), "action1"];

  compareWithFnServiceRequested(a: string, b: string): boolean {
    return a === b;
  }
}
